/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.anthropic.integration.rpc.AppSettingsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type AnthropicAppError = {
  chirpErrorMessage: Default<string>;
  type: ErrorType;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ApiKeyUpdateRequest = { apiKey: string };

export type ApiKeyUpdateResponse = {};

export type AppInstallRequest = { apiKey: string };

export type AppInstallResponse = { responseField: string };

export type ErrorType = 'INVALID_API_KEY' | unhandledEnumCase;

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type InstallRequestType = Requestify<AppInstallRequest>;
export type InstallResponseType = AppInstallResponse;
export type InstallErrorType = AnthropicAppError & HubspotMetadata;
export const installRpc: ChirpAvroRpcDetails<
  InstallRequestType,
  InstallResponseType,
  InstallErrorType,
  false
> = {
  serviceName: 'com.hubspot.anthropic.integration.rpc.AppSettingsRpc',
  rpcName: 'install',
  auth: 'app',
  fingerprint: 'Y9TUur42H_xef3Jhxa0zqIzwybuKcMMr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UninstallResponseType = AppInstallResponse;
export type UninstallErrorType = AnthropicAppError & HubspotMetadata;
export const uninstallRpc: ChirpAvroRpcDetails<
  undefined,
  UninstallResponseType,
  UninstallErrorType,
  false
> = {
  serviceName: 'com.hubspot.anthropic.integration.rpc.AppSettingsRpc',
  rpcName: 'uninstall',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABef3Jhxa0zqIzwybuKcMMr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpsertApiKeyRequestType = Requestify<ApiKeyUpdateRequest>;
export type UpsertApiKeyResponseType = ApiKeyUpdateResponse;
export type UpsertApiKeyErrorType = AnthropicAppError & HubspotMetadata;
export const upsertApiKeyRpc: ChirpAvroRpcDetails<
  UpsertApiKeyRequestType,
  UpsertApiKeyResponseType,
  UpsertApiKeyErrorType,
  false
> = {
  serviceName: 'com.hubspot.anthropic.integration.rpc.AppSettingsRpc',
  rpcName: 'upsertApiKey',
  auth: 'app',
  fingerprint: 'bVgwIzXuX0kSuYkk3Cx4IYzwybuKcMMr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
